import { render, staticRenderFns } from "./IncapacidadesRamas.vue?vue&type=template&id=abfd81a8&scoped=true"
import script from "./IncapacidadesRamas.vue?vue&type=script&lang=js"
export * from "./IncapacidadesRamas.vue?vue&type=script&lang=js"
import style0 from "./IncapacidadesRamas.vue?vue&type=style&index=0&id=abfd81a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfd81a8",
  null
  
)

export default component.exports